import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppPatientsModule } from "../patients/patients.module";
import { AnamneseComponent } from "./anamnese.component";
import { AnamnesePatientComponent } from "./anamnese-patient/anamnese-patient.component";
import { AnamneseSetupComponent } from "./anamnese-setup/anamnese-setup.component";
import { AnamneseTreatmentComponent } from "./anamnese-treatment/anamnese-treatment.component";
import { AnamneseProductSelectionComponent } from "./anamnese-treatment/anamnese-product-selection/anamnese-product-selection.component";
import { AnamneseOptionsComponent } from "./anamnese-treatment/anamnese-options/anamnese-options.component";
import { AnamneseAddressesComponent } from "./anamnese-setup/anamnese-addresses/anamnese-addresses.component";
import { AnamneseAdditionalSettingsComponent } from "./anamnese-setup/anamnese-additional-settings/anamnese-additional-settings.component";
import { AnamneseFileuploadComponent } from "./anamnese-setup/anamnese-fileupload/anamnese-fileupload.component";
import { AnamneseOrderComponent } from "./anamnese-setup/anamnese-order/anamnese-order.component";
import { AnamneseQuestionaireComponent } from "./anamnese-treatment/anamnese-questionaire/anamnese-questionaire.component";
import { AnamneseQuestionaireSimpleComponent } from "./anamnese-treatment/anamnese-questionaire/anamnese-questionaire-simple/anamnese-questionaire-simple.component";
import { TreatmentsModule } from "../treatments/treatments.module";
import { AnamneseOptionsJawsComponent } from "./anamnese-treatment/anamnese-options/jaws/jaws.component";
import { CustomOptionsComponent } from "./anamnese-treatment/anamnese-options/custom-options/custom-options.component";
import { ToothAreaSelectionComponent } from "./anamnese-treatment/anamnese-options/custom-options/tooth-area-image-selection/tooth-area-image-selectioncomponent";
import { AnamneseTransferComponent } from './anamnese-setup/anamnese-transfer/anamnese-transfer.component';
import { AnamneseQuestionnaireOrcadentComponent } from "./anamnese-treatment/anamnese-questionnaire-orcadent/anamnese-questionnaire-orcadent.component";
import { AnamneseQuestionnaireMichiganComponent } from "./anamnese-treatment/anamnese-questionnaire-michigan/anamnese-questionnaire-michigan.component";
import { ThreeOptionsFormComponent } from "./anamnese-treatment/anamnese-questionnaire-orcadent/form-components/three-options-form/threeOptionsForm.component";
import { OcclusalHeightFormComponent } from "./anamnese-treatment/anamnese-questionnaire-orcadent/form-components/occlusal-height-form/occlusalHeightForm.component";

import { MiddlelineFormComponent } from "./anamnese-treatment/anamnese-questionnaire-orcadent/form-components/middleline-form/middlelineForm.component";
import { AttachmentPositionMovementFormComponent } from "./anamnese-treatment/anamnese-questionnaire-orcadent/form-components/attachment-position-movement-form/attachmentPositionMovementForm.component";
import { AnteriorTeethFormComponent } from "./anamnese-treatment/anamnese-questionnaire-orcadent/form-components/anterior-teeth-form/anteriorTeethForm.component";
import { PosteriorTeethFormComponent } from "./anamnese-treatment/anamnese-questionnaire-orcadent/form-components/posterior-teeth-form/posteriorTeethForm.component";
import { AnamneseFileuploadOrcadentComponent } from "./anamnese-setup/anamnese-fileupload-orcadent/anamnese-fileupload-orcadent.component";
import { AnamneseOrcadentImagesComponent } from "./anamnese-setup/anamnese-fileupload-orcadent/anamnese-images-orcadent/anamnese-images-orcadent.component";
import { CaTreatmentsModule } from "libs/treatments/src/lib/treatments.module";
import { MaterialModule } from "libs/material/src/lib/material.module";
import { MediaModule } from "libs/media/src/lib/media.module";
import { QuestionaireModule } from "libs/questionaire/src/lib/questionaire.module";
import { CaTranslateModule } from "libs/translate/src/lib/translate.module";
import { UxComponentsModule } from "libs/ux-components/src/lib/ux-components.module";
import { TmCommonModule } from "libs/tm-common/src/lib/tm-common.module";


@NgModule({
	imports: [
		CommonModule,
		CaTranslateModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		AppPatientsModule,
		MediaModule,
		QuestionaireModule,
		CaTreatmentsModule,
		TreatmentsModule,
		TmCommonModule,
		UxComponentsModule,
		ThreeOptionsFormComponent,
		OcclusalHeightFormComponent,
		MiddlelineFormComponent,
		AnteriorTeethFormComponent,
		PosteriorTeethFormComponent,
		AttachmentPositionMovementFormComponent
	],
	declarations: [
		AnamneseComponent,
		AnamnesePatientComponent,
		AnamneseSetupComponent,
		AnamneseTreatmentComponent,
		AnamneseOptionsComponent,
		AnamneseProductSelectionComponent,
		AnamneseAddressesComponent,
		AnamneseAdditionalSettingsComponent,
		AnamneseOrderComponent,
		AnamneseQuestionaireComponent,
		AnamneseQuestionaireSimpleComponent,
		AnamneseQuestionnaireOrcadentComponent,
		AnamneseQuestionnaireMichiganComponent,
		AnamneseOptionsJawsComponent,
		CustomOptionsComponent,
		ToothAreaSelectionComponent,
		AnamneseFileuploadComponent,
		AnamneseFileuploadOrcadentComponent,
		AnamneseOrcadentImagesComponent,
		AnamneseTransferComponent]
})
export class AnamneseTmModule {}
